import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import LightBuyer from 'components/headers/lightBuyer';
import { Modal, Button, Form } from 'react-bootstrap';  // Import Modal and Form from react-bootstrap
import Swal from 'sweetalert2';  // Import SweetAlert
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import AnnouncementBanner from 'components/AnnouncementBanner';

const BuyerDashboard = () => {
    const [isBuyer, setIsBuyer] = useState(false);
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [amount, setAmount] = useState('');
    const [stockData, setStockData] = useState({
        totalStock: 0,
        stockSold: 0,
        stockLeft: 0,
    });
    const token = localStorage.getItem('authToken');
    const [retraite, setRetraite] = useState();

    const [showModal, setShowModal] = useState(false); // To manage modal visibility

    useEffect(() => {
        checkBuyerRole();
getTotalAmount();
        fetchStockData(); // Fetch stock data when the component is mounted
    }, []);

    const checkBuyerRole = () => {
        const isBuyer = localStorage.getItem('role') === 'buyer';
        setIsBuyer(isBuyer);

        if (isBuyer) {
            console.log(' ');
        } else {
            navigate('/login');
            console.error('Unauthorized: User is not a buyer');
        }
    };

const fetchStockData = async () => {
        try {
            const token = localStorage.getItem('authToken'); // Get token from localStorage

            // If no token is found, log the error and return
            if (!token) {
                console.error('No authentication token found.');
                return;
            }

            // Call the backend API to fetch stock data with the token in the authorization header
            const response = await axios.get('https://hbmdijital.online/api/get-stock-data', {
                headers: {
                    Authorization: `Bearer ${token}`, // Add token to the Authorization header
                },
            });

            // Check if the response indicates account deletion
            if (response.data.error === 'Your account has been deleted.') {
                // Display error alert
                Swal.fire('Erreur!', 'Votre compte a été supprimé.', 'error');
                localStorage.clear(); // Clear localStorage to remove authentication token
                navigate('/signup'); // Redirect to signup page
                return; // Exit the function
            }

            // Update the state with fetched data if account is not deleted
            setStockData(response.data);

        } catch (error) {
            // Handle the error if the request fails
            console.error('Error fetching stock data', error);
            
            // Handle 401 Unauthorized specifically if error.response exists
            if (error.response && error.response.status === 401) {
                Swal.fire('Erreur!', 'Votre compte a �t� supprim�.', 'error');
                localStorage.clear();
                navigate('/signup'); // Redirect to signup page
            }
        }
    };
  const handleRequestStock = async (e) => {
        e.preventDefault();
        if (!token) {
            console.error('No authentication token found.');
            return;
        }
        try {
            const response = await axios.post(
                'https://hbmdijital.online/api/buyer/request-stock',
                { amount },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            if (response.status === 200) {
                Swal.fire({
                    title: 'Stock demandé',
                    text: `Montant demandé: ${amount}`,
                    icon: 'success',
                    confirmButtonText: 'OK',
                });
                fetchStockData();
                setShowModal(false);
            }
        } catch (error) {
            console.error('Error requesting stock', error);
            Swal.fire({
                title: 'Erreur',
                text: 'Une erreur s\'est produite lors de la demande de stock.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };

    const handleWithdrawalRequest = async () => {
        try {
            const token = localStorage.getItem('authToken');
    
            if (!token) {
                console.error('No authentication token found.');
                return;
            }
    
            console.log('Token', token);  // Log the token
    
            // Sending an empty request body since you don't need to send the amount
            const response = await axios.post(
                'https://hbmdijital.online/api/buyer/request-withdrawal',
                {},  // Empty object as payload
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
    
            if (response.status === 200) {
                Swal.fire({
                    title: 'Demande de retrait',
                    text: `Montant demandé: ${stockData.stockSold}`,
                    icon: 'success',
                    confirmButtonText: 'OK',
                });
            }
        } catch (error) {
            console.error('Error requesting withdrawal', error);
            Swal.fire({
                title: 'Erreur',
                text: 'Une erreur s\'est produite lors de la demande de retrait.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };
    const navigate = useNavigate(); // Hook for navigation

const getTotalAmount= async() =>{
  try {

    if (!token) {
      console.log('Token not found. Please login first.');
      return;
    }

    // Make the Axios request asynchronously
    const response = await axios.get('https://hbmdijital.online/api/buyer/total-amount', {
      headers: {
        Authorization: `Bearer ${token}` // Use the retrieved token
      }
    });

    // Log the response in the console
setRetraite(response.data.total_amount);
  } catch (error) {
    // Handle any errors
    console.error('Error:', error.response ? error.response.data : error.message);
  }
}


    return (
        <AnimationRevealPage>
            <LightBuyer />
            <AnnouncementBanner />

            <div className="d-flex">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h1 className="text-dark display-4">Tableau de bord de l'acheteur</h1>
                        <Button
  className="btn"
  style={{ backgroundColor: '#1e3d56', color: 'white', border: 'none', width: 'auto', fontSize: '14px', padding: '6px 12px' }}    onClick={() => setShowModal(true)}  // Show the modal when clicked
>
    Acheter un nouveau stock
</Button>

<button
    className="btn"
    style={{ backgroundColor: '#1e3d56', color: 'white', border: 'none', width: 'auto', fontSize: '14px', padding: '6px 12px' }}
    onClick={handleWithdrawalRequest}
>
    Demander un retrait
</button>

                        
                    </div>

                    <hr className="my-4" />
                   
                    <div className="row">
    <div className="col-md-4 mb-3">
        <div className="card" style={{ backgroundColor: '#1e3d56', color: 'white' }} p-3 shadow>
            <div className="card-body">
                <h6 className="card-title">La somme d'achat de stock</h6>
                <p className="card-text fs-3">{stockData.totalStock}</p>
            </div>
        </div>
    </div>

    <div className="col-md-4 mb-3">
        <div className="card" style={{ backgroundColor: '#4b7c8b', color: 'white' }} p-3 shadow>
            <div className="card-body">
                <h6 className="card-title">Combien vendre</h6>
                <p className="card-text fs-3">{stockData.stockSold}</p>
            </div>
        </div>
    </div>

    <div className="col-md-4 mb-3">
        <div className="card" style={{ backgroundColor: '#3f5f72', color: 'white' }} p-3 shadow>
            <div className="card-body">
                <h6 className="card-title">Combien reste</h6>
                <p className="card-text fs-3">{stockData.stockLeft}</p>
            </div>
        </div>
    </div>
    <div className="col-md-4 mb-3">
        <div className="card" style={{ backgroundColor: '#3f5f76', color: 'white' }} p-3 shadow>
            <div className="card-body">
                <h6 className="card-title">Total des retraites </h6>
                <p className="card-text fs-3">{retraite}</p>
            </div>
        </div>
    </div>

</div>



                    {/* Modal for adding stock */}
                    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Ajouter du stock</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form onSubmit={handleRequestStock}>
                                <Form.Group>
                                    <Form.Label>Sélectionnez le montant</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={amount}
                                        onChange={(e) => setAmount(e.target.value)}
                                    >
                                        <option value="">Sélectionner</option>
                                        <option value="5000">5000</option>
                                        <option value="10000">10000</option>
                                        <option value="15000">15000</option>
                                        <option value="20000">20000</option>
                                    </Form.Control>
                                </Form.Group>
                                <br/>
                                <Button variant="primary" type="submit" className="btn"
    style={{ backgroundColor: '#1e3d56', color: 'white', border: 'none', width: 'auto', fontSize: '14px', padding: '6px 12px' }}>
                                    Soumettre
                                </Button>
                            </Form>
                        </Modal.Body>
                    </Modal>
                </section>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default BuyerDashboard;
